import { Routes } from '@angular/router';

import { roles } from '@shared/constants';
import { ClientApps } from '@shared/models';
import {
  authorizeGuard,
  disclaimerGuard,
  pendingChangesGuard,
  roleGuard,
} from '@shared/services/guards';
import { lendingTypeResolver } from './services';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    data: { roles: [roles.lender, roles.packager], client: ClientApps.LenderHub },
  },
  {
    path: 'ignite',
    loadChildren: () => import('@clubhub/ignite/ignite.module').then((m) => m.IgniteModule),
    canActivate: [authorizeGuard, disclaimerGuard],
    data: { roles: [roles.lender], client: ClientApps.LenderHub },
  },
  {
    path: 'product-upload',
    loadComponent: () => import('./pages/product-upload/product-upload.component').then(m => m.ProductUploadComponent),
    resolve: { lendingTypes: lendingTypeResolver },
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    canDeactivate: [pendingChangesGuard],
    data: { roles: [roles.product, roles.packager], client: ClientApps.LenderHub },
  },
  {
    path: 'bridging-product-upload',
    loadComponent: () => import('./pages/product-upload/product-upload.component').then(m => m.ProductUploadComponent),
    resolve: { lendingTypes: lendingTypeResolver },
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    data: { roles: [roles.product, roles.packager], client: ClientApps.LenderHub },
  },
  {
    path: 'audit-history',
    loadComponent: () => import('./pages/audit-history/audit-history.component').then(m => m.AuditHistoryComponent),
    resolve: { lendingTypes: lendingTypeResolver },
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    data: { roles: [roles.igniteAudit], client: ClientApps.LenderHub },
  },
  {
    path: 'esis',
    loadChildren: () => import('./pages/esis/esis.module').then((m) => m.ESISModule),
    resolve: { lendingTypes: lendingTypeResolver },
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    data: { roles: [roles.lenderEsisConfiguration], client: ClientApps.LenderHub },
  },
  {
    path: 'all-products',
    loadComponent: () => import('./pages/all-products/all-products.component').then(m => m.AllProductsComponent),
    resolve: { lendingTypes: lendingTypeResolver },
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    data: { roles: [roles.product], client: ClientApps.LenderHub },
  },
  {
    path: 'bridging-all-products',
    loadComponent: () => import('./pages/all-products/all-products.component').then(m => m.AllProductsComponent),
    resolve: { lendingTypes: lendingTypeResolver },
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    data: { roles: [roles.product], client: ClientApps.LenderHub },
  },
  { path: 'criteria', redirectTo: 'criteria-v2/dashboard', pathMatch: 'full' },
  { path: 'criteria/**', redirectTo: 'criteria-v2/dashboard' },
  {
    path: 'criteria-v2',
    loadChildren:
      () => import('./pages/criteria-v2/criteria-v2.module').then((m) => m.CriteriaV2Module),
    resolve: { lendingTypes: lendingTypeResolver },
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    data: { roles: [roles.lender], client: ClientApps.LenderHub },
  },
  {
    path: 'mi/completions-paid',
    loadComponent: () => import('./pages/mi/mi-completions-paid/mi-completions-paid.component').then(m => m.MiCompletionsPaidComponent),
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    data: { roles: [roles.lender, roles.lenderPaidMiRoles.paidCompletionsMi], client: ClientApps.LenderHub },
  },
  {
    path: 'mi/hosted',
    loadComponent: () => import('./pages/mi/mi-hosted/mi-hosted.component').then(m => m.MiHostedComponent),
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    data: { roles: [roles.lender, roles.lenderPaidMiRoles.hostedMi], client: ClientApps.LenderHub },
  },
  {
    path: 'mi/surveying-services',
    loadComponent: () =>
      import('./pages/mi/mi-surveying-services/mi-surveying-services.component').then(m => m.MiSurveyingServicesComponent),
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    data: { roles: [roles.lender, roles.lenderPaidMiRoles.lGSSLenderSpecificMI, roles.lenderPaidMiRoles.lGSSNewBuildMI],
      client: ClientApps.LenderHub },
  },
  {
    path: 'mi/:reportpath',
    loadComponent: () =>
      import('./pages/mi/mi-generic-report-viewer/mi-generic-report-viewer.component').then(m => m.MiGenericReportViewerComponent),
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    data: { roles: [roles.lenderPaidMi], client: ClientApps.LenderHub },
  },
  {
    path: 'manage-affordability/:lendingTypeCode',
    loadComponent: () =>
      import('./pages/affordability-management/affordability-management.component').then(m => m.AffordabilityManagementComponent),
    canActivate: [authorizeGuard, roleGuard, disclaimerGuard],
    canDeactivate: [pendingChangesGuard],
    data: { roles: [roles.lender, roles.affordabilityManager], client: ClientApps.LenderHub },
  },
  {
    path: 'contact',
    loadComponent: () => import('@shared/pages/contact-page/contact-page.component')
      .then(m => m.ContactPageComponent), data: { isLenderHub: true },
  },
  {
    path: 'error',
    loadComponent: () => import('@shared/pages/error-page/error-page.component').then(m => m.ErrorPageComponent),
  },
];
